import React from 'react'
import { DashboardCard } from './OutstandingBalance'
import { useTheme } from '../../../middleware/ThemeContext'
import CardIconHeader from './Components/CardIconHeader';
import ContactRoleIcon from '../../../assets/icons/ContactRoleIcon';
import styled from 'styled-components';
import StyledText from '../../../components/StyledComponents/StyledText';
import { font } from '../../../utils/themes';
import { Button } from '../../../components/form/Button';
import ArrowIcon from '../../../assets/icons/ArrowIcon';

const data = [
    {
        label: 'Alice Cooper',
        progress: 85,
    },
    {
        label: 'Bob Marleyt',
        progress: 40,
    },
    {
        label: 'Charlie Putth',
        progress: 60,
    }
];

const AlmostMembers = () => {
    const {theme} = useTheme();
  return (
    <DashboardCard theme={theme} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div>
            <CardIconHeader 
                icon={<ContactRoleIcon size={24} Color={theme.CorporateTheme.colors.ultraMarineBlue} /> }
                title='Almost Members'
                count="85"
                iconBgColor='rgba(228, 228, 255, 0.5)'
            />
            <hr />
        </div>
        <div style={{ margin: '30px 0px', }}>
            {data.map((item, index) => (
            <div key={index} style={{ marginBottom: '30px' }}>
                <div className='d-flex align-items-center justify-content-between mb-2'>
                    <StyledText
                        fontSize='14px'
                        fontWeight={600}
                        textColor={theme.CorporateTheme.colors.textSecondary}
                    >
                        {item.label}
                    </StyledText>
                    <StyledText
                        fontSize='14px'
                        fontWeight={600}
                        textColor={theme.CorporateTheme.colors.redOrange}
                        fontFamily={font.lato}
                    >
                        {item.progress}% Complete
                    </StyledText>
                </div>
                <ProgressBar>
                    <Progress width={item.progress} color={theme.CorporateTheme.colors.blueberry} />
                </ProgressBar>
            </div>
            ))}
        </div>
        <Button
            theme={theme}
            $variant='customButton'
            textColor={theme.CorporateTheme.colors.primary}
            color={theme.CorporateTheme.colors.primary}
            fontSize='12px'
            fontWeight='600'
            borderColor={theme.CorporateTheme.colors.filterBG}
            width='100%'
            textPosition='start'
        >
            View all Almost Members
            <ArrowIcon rotate='right' color={theme.CorporateTheme.colors.gunmetal} />
        </Button>
    </DashboardCard>
  )
}

const ProgressBar = styled.div`
  height: 5px;
  background: #eee;
  border-radius: 3px;
  overflow: hidden;
`;

const Progress = styled.div<{ width: number, color: string }>`
  height: 100%;
  width: ${(props) => props.width}%;
  background-color: ${(props) => props.color};
  transition: width 0.3s ease;
`;

export default AlmostMembers